export function validateAddressFieldsLength(
  address?: Record<string, any> | null,
  opts?: { prefixed?: string; maxLength?: number; shouldValidate?: boolean },
) {
  if (!address) {
    return undefined
  }
  const maxLength = opts?.maxLength
  if (!maxLength || !opts.shouldValidate) {
    return undefined
  }
  const fields = ["line_1", "line_2", "line_3", "line_4", "city", "county"].map(field => {
    if (opts?.prefixed) {
      return `${opts.prefixed}${field}`
    }
    return field
  })

  const errors: Record<string, string> = {}
  fields.forEach(field => {
    if (address[field]) {
      if (address[field].length > maxLength) {
        errors[field] = `must be less than ${maxLength} characters`
      }
    }
  })
  return Object.keys(errors).length > 0 ? errors : undefined
}
